import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { BookAppointmentComponent } from "./book-appointment/book-appointment.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./auth/auth.guard";

import { AppComponent } from "./app.component";
// import { BeerListComponent } from './beer-list/beer-list.component';
import { HeaderComponent } from "./header/header.component";
import { LoginFormComponent } from "./login-form/login-form.component";
import { FooterComponent } from "./footer/footer.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { MyDetailsComponent } from "./my-details/my-details.component";
import { DeceasedProfileComponent } from "./deceased-profile/deceased-profile.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { BookHistoryComponent } from "./book-history/book-history.component";

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "login", component: LoginFormComponent },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "mydetails",
    component: MyDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "deceasedprofile",
    component: DeceasedProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "bookhistory",
    component: BookHistoryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "bookappointment",
    component: BookAppointmentComponent,
    canActivate: [AuthGuard]
  },
  { path: "maintenance", component: MaintenanceComponent },
  { path: "resetPassword", component: ForgotPasswordComponent },


  { path: "**", redirectTo: "/dashboard", pathMatch: "full" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
